export enum PricingCopilotCustomUtilitiesRankAggregateType {
	PRODUCT = 'PRODUCT',
	UTILITY = 'UTILITY',
	EXPORT = 'EXPORT',
}

export class PricingCopilotCustomUtilitiesRankReport {
	public stateId: string;
	public stateShort: string;
	public product: string;
	public utilityName: string;
	public utilityId: string;
	public totalBidsSubmitted: number;
	public averageDelta: number;
	public deltaToWin: number;
	public deltaToMedian: number;
	public averageRank: number;
	public firstPlace: number;
	public secondPlace: number;
	public contractUsage: number;

	public identifier: string;

	constructor(pricingCopilotCustomUtilitiesRankReport?: PricingCopilotCustomUtilitiesRankReport) {
		Object.assign(this, pricingCopilotCustomUtilitiesRankReport);
		this.identifier = `${this.stateId}-${this.utilityId}-${this.product}`;
	}
}
